import {Modal} from '@/components/atoms'
import {MODAL_TYPE} from '@/utils/constants/globalStyle'
import {SegmentTypes} from '@/utils/constants/promotionConstants'
import {useState} from 'react'
import {SegmentModalListContent} from './SegmenListContent'
import {SegmentFolderContent} from './SegmentFoldersContent'
import './segmentModal.scss'

/**
 * @typedef {import('@/types/promotionTypes.js').SegmentDetails} SegmentDetails
 */

/**
 * @typedef {Object} SegmentModalProps
 * @property {boolean} show - Whether to show the modal
 * @property {string} type - Type of segment selection (SEGMENT_FOLDER or SEGMENT_LIST)
 * @property {() => void} onClose - Callback when modal is closed
 * @property {() => void} onSubmit - Callback when selections are submitted
 * @property {SegmentDetails[]} existingSelections - Already selected segments
 * @property {number | null} groupIndex - Index of the group or null
 */

/**
 * Modal for selecting segments or segment folders
 * @param {SegmentModalProps} props
 */
export const SegmentModal = ({show, type, onClose, onSubmit, existingSelections, groupIndex}) => {
  const [selectedSegments, setSelectedSegments] = useState(existingSelections || [])

  const handleSubmit = () => {
    onSubmit(selectedSegments, groupIndex, type)
    onClose()
  }

  const getModalTitle = () => {
    switch (type) {
      case SegmentTypes.SEGMENT_FOLDER:
        return 'Segment'
      case SegmentTypes.SEGMENT_LIST:
        return 'Segments'
      default:
        return ''
    }
  }

  const getModalText = () => {
    switch (type) {
      case SegmentTypes.SEGMENT_FOLDER:
        return 'Segment Folder'
      case SegmentTypes.SEGMENT_LIST:
        return 'Segment List'
      default:
        return ''
    }
  }

  return (
    <Modal
      showModal={show}
      title={getModalTitle()}
      text={getModalText()}
      primaryButtonDisabled={false}
      primaryButtonText="Apply"
      tertiaryButtonText="Cancel"
      showTertiaryButton={true}
      content={
        type === SegmentTypes.SEGMENT_FOLDER ? (
          <SegmentFolderContent selectedSegments={selectedSegments} setSelectedSegments={setSelectedSegments} />
        ) : (
          <SegmentModalListContent selectedSegments={selectedSegments} setSelectedSegments={setSelectedSegments} />
        )
      }
      type={MODAL_TYPE.LARGE}
      onClickTertiaryButton={onClose}
      onClickPrimaryButton={handleSubmit}
      hideCloseButton={true}
      className="products-promotions-segment-modal"
    />
  )
}
